export const maxWidths = {
  md: '768px',
  lg: '992px',
  xl: '1230px',
  '2xl': '1440px',
};
